import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Translator, TRANSLATOR } from '@miq/utils';
import { DigitalAssistantComponent } from '../digital-assistant.component';
import { ChatBotOverlayService } from '../components/chat/services/chat-bot-overlay.service';
import { outputToObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OverlayModule } from '@angular/cdk/overlay';
import { PositionType } from '../components/chat/services/chat-bot-overlay.helper';

@Component({
  selector: 'miq-digital-assistant-button',
  imports: [CommonModule, MatIconModule, MatTooltipModule, OverlayModule],
  providers: [ChatBotOverlayService],
  template: `
    <div
      class="chat-bot-assistant"
      #chatBtn
      [ngClass]="{ 'chat-bot-assistant--open': chatBotOverlayService.isChatBotOpen() }"
      matTooltipClass="tooltip-action-icon__how-to-videos"
      (click)="openChatWindow(chatBtn)"
      >
      @if (chatBotOverlayService.isChatBotOpen()) {
        <span class="chat-bot-icon expand-more"> <ng-content select="[chatOpen]"></ng-content></span>
      }
      @if (!chatBotOverlayService.isChatBotOpen()) {
        <mat-icon class="chat-bot-icon" svgIcon="ellis-ai-avatar"></mat-icon>
      }
    </div>
    `,
  styleUrl: './digital-assistant-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DigitalAssistantButtonComponent {
  readonly userInfo = input<Record<string, any>>({});
  readonly overlayPosition = input<PositionType>('below');
  public chatBotToolTip: string;

  public chatBotOverlayService = inject(ChatBotOverlayService);
  private readonly destroyRef = inject(DestroyRef);

  constructor(@Inject(TRANSLATOR) translation: Translator) {
    this.chatBotToolTip = translation.translate('admin.digitalAssistant', {});
  }

  openChatWindow(btnEl: HTMLElement): void {
    const { componentRef } = this.chatBotOverlayService.openChat(
      btnEl,
      DigitalAssistantComponent,
      this.overlayPosition()
    );
    componentRef.userInfo.set(this.userInfo());
    outputToObservable(componentRef.emitCloseChat).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => this.destroyChatWindow(componentRef),
      error: (err: any) => console.error('Error in emitCloseChat subscription:', err),
    });
  }

  private destroyChatWindow(componentRef): void {
    if (componentRef) {
      this.chatBotOverlayService.closeChat();
    }
  }
}
